import config from '../config';

export type BrandConfig = {
  privacyPolicyUrl: string;
  contactUsURL: string;
  hostDomain: string;
};

/**
 * Get brand configuration including privacy policy URL
 */
export const getBrandConfig = (): BrandConfig => {
  const hostDomain = config.HOST_DOMAIN;

  return {
    privacyPolicyUrl: `https://${hostDomain}/information/privacy-policy`,
    contactUsURL: `https://${hostDomain}/contact-us`,
    hostDomain,
  };
};

// APP_NAME is prefixed with the build environment (e.g. "DEV SipnSave",
// "BETA Bottlemart") in non-prod env files. User-facing copy must show the
// brand name only — strip the leading env tag so prod and pre-prod builds
// render the same brand label.
export const getBrandDisplayName = (): string =>
  (config.APP_NAME ?? '')
    .trim()
    .replace(/^(DEV|BETA|PROD|UAT|STAGING)\s+/i, '')
    .trim();
